import React, { useContext, useState, useEffect, useRef } from 'react';
import { StyledAllFilterContainer } from './index.styles';
import { BrandsFilterComponent } from '../brandFilters';
import { AmenitiesFilterComponent } from '../amenitiesFilters';
import { ShowAvailableFiltersComponent } from '../availabilityFilters';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import clsx from 'clsx';
import PriceFilter from '../priceFilters';
import { TransportationFilterComponent } from '../transportationFilters';
import { CityFilterComponent } from '../citiesFilter';
import { StateFilterComponent } from '../statesFilter';
import { HotelTypeFilterComponent } from '../hotelTypeFilters';
import { EventsFilterComponent } from '../eventsFilters';
import { ActivitiesFilterComponent } from '../activitiesFilters';
import { Modal } from '@marriott/mi-ui-library';
import {
  SearchFacetsConstants,
  SearchFacetsList,
  DefaultValue,
  SearchFacetsListCodes,
  COUNTRY_LIST_SHOW_FULL_PRICE_BY_DEFAULT,
  quickFiltersAndAmenitiesHiddenCodes,
  SearchSortFields,
} from '../../organisms/SearchResults/index.constant';
import {
  SearchStateExtendsType,
  SearchStateFilterObj,
  SearchFacetsResponse,
  SearchFacetsResponseBuckets,
} from '../../organisms/SearchResults/store/store.type';
import {
  SearchFilterContext,
  SearchResultAlertContext,
  SearchResultContext,
} from '../../organisms/SearchResults/index.context';
import {
  getSearchFilterClearState,
  getSearchFilterInitialState,
  getSearchAppliedFilter,
  SearchActions,
  updateQueryParamsFromSession,
} from '../../organisms/SearchResults/store/store.action';
import DistanceFilterComponent from '../distanceFilters';
import PointsFilter from '../pointsFilter';
import { AllFiltersProps } from './index.types';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { Button } from '@marriott/mi-ui-library';
import { useSessionUpdateContext } from '../../context/SessionUpdateContext';
import { usePageContext } from '../../context/PageContext';
import { getUserCountryCodeFromAkamai } from '../../utils';
import { useCheckBreakpoint } from '@marriott/mi-ui-library';
import {
  enableBoostBrands,
  filterBrands,
  getTotalFilterCount,
  updateQueryParams,
} from '../../organisms/SearchResults/lib/helper';

export const AllFiltersComponent: React.FC<AllFiltersProps> = ({
  hideAvailabiltyFilters,
  hideDistanceFilters,
  hideTaxesToggle,
  filterData,
  hidePriceFilters,
  isStateSearch,
  isDestinationSearch,
  setFetchCurrencyConversionFactors,
  tooltipRefElement,
  setTooltipContent,
  modalRefElement,
}) => {
  const clickTrackingLoc = 'Phoenix Search Results';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { setFeatureSelected, jsonContent, isMapViewEnabled, setIsTaxesandFeesIncludedFromPopup }: any =
    useContext(renderedData);
  const { searchQueryState, setSearchQuery } = useContext(SearchFilterContext);
  const { headersData, isDTT } = usePageContext();
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const [filterSelectionData, setFilterSelectionData] = useState<SearchStateExtendsType | undefined | null>(
    getSearchFilterInitialState(searchQueryState)
  );
  const { searchResultAlerts } = useContext(SearchResultAlertContext);
  const [updatedFilterSelectionData, setUpdatedFilterSelectionData] = useState<
    SearchStateExtendsType | undefined | null
  >(getSearchFilterInitialState(searchQueryState));

  const [popupOpenState, setPopupOpenState] = useState(false);
  const [includeTaxes, setIncludeTaxes] = useState<boolean>(searchQueryState[SearchFacetsConstants.includeTaxes]);
  useEffect(() => {
    if (includeTaxes !== searchQueryState[SearchFacetsConstants.includeTaxes]) {
      setIncludeTaxes(searchQueryState[SearchFacetsConstants.includeTaxes]);
    }
  }, [searchQueryState[SearchFacetsConstants.includeTaxes]]);
  const [currCurrency, setCurrCurrency] = useState<string>(searchQueryState.currentCurrency);
  const [isUnavailableProperties, setIsUnavailableProperties] = useState<boolean>(
    searchQueryState[SearchFacetsConstants.unavailableProperties]
  );
  const [filterCount, setFilterCount] = useState(0);
  const [isFilterUpdate, setIsFilterUpdated] = useState<boolean>(false);
  const [currFilterData, setCurrFilterData] = useState<Array<SearchFacetsResponse> | undefined>(filterData);
  const [filtersActive, setAllFiltersActive] = useState(false);
  const { searchResult } = useContext(SearchResultContext);
  const [categorizedBrands, setCategorizedBrands] = useState(jsonContent?.categorizedBrandsArray);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const isDesktop = useCheckBreakpoint('viewportM'); // check if viewport is desktop till 768px
  const [isTaxesAndFeesToggled, setIsTaxesAndFeesToggled] = useState(false); // state to check if user has toggled the taxesAndFees switch
  const bodyRef = useRef<HTMLBodyElement | null>(null);

  // to updates brands enabled/disabled state based on the UXL response
  const updateCategorizedBrands = () => {
    const brands = searchResult?.facets?.find(key => key.type.enumCode === SearchFacetsList.brand);
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    categorizedBrands?.forEach((brandCategory: { brandsLabelListItems: any }) => {
      brandCategory?.brandsLabelListItems?.forEach((brand: { brandTagId: string | number; disable: boolean }) => {
        const enabledBrand = brands?.buckets?.find(
          availableBrand => brand?.brandTagId === availableBrand?.code && availableBrand?.count > 0
        );
        if (enabledBrand) {
          brand.disable = false;
        }
      });
    });
    setCategorizedBrands(categorizedBrands);
  };

  const getFilterCount = (): number => {
    let filterCount = 0;
    Object.keys(SearchFacetsList)?.forEach((filterType, _filterKey) => {
      let tempSearchData = searchQueryState[SearchFacetsList[filterType as keyof typeof SearchFacetsList]];
      let isRangeFilter = false;
      if (filterType === 'BRANDS') {
        tempSearchData = filterBrands(categorizedBrands, searchQueryState[SearchFacetsList.brand]);
      } else if (
        ['PRICE', 'POINTS', 'DISTANCE'].includes(SearchFacetsList[filterType as keyof typeof SearchFacetsList])
      ) {
        isRangeFilter = true;
        const rangeFilterIndex = Object.keys(tempSearchData ?? {})[0];
        if (rangeFilterIndex) {
          const rangeFilterData = searchQueryState?.filter
            ?.find(filterObj => filterObj?.['type']?.['code'] === filterType.toLocaleLowerCase())
            ?.buckets?.find(rangeFilterBucket => rangeFilterBucket?.index === parseInt(rangeFilterIndex));
          tempSearchData = {
            [`${rangeFilterData?.start}-${rangeFilterData?.end}`]: rangeFilterIndex,
          };
        }
      }
      const filterValues = Object.keys(tempSearchData ?? {}); //user selected filter values for a particular filter(eg: amenities) from session
      const validFilterDataFromUXL = searchResult?.facets?.find(
        uxlFacet => uxlFacet['type'].code === SearchFacetsListCodes[filterType as keyof typeof SearchFacetsList]
      ); // filter values from UXL for the corresponding filter from session
      if (validFilterDataFromUXL?.['buckets'] && validFilterDataFromUXL['buckets'].length) {
        validFilterDataFromUXL?.['buckets']?.forEach((bucket: SearchFacetsResponseBuckets) => {
          if (isRangeFilter && filterValues[0] === `${bucket?.start}-${bucket?.end}` && bucket['count'] > 0) {
            //if user selected range filter is availabe in UXL resplonse then increase count
            filterCount++;
          } else if (filterValues?.includes(bucket.code as string) && bucket['count'] > 0) {
            //if user selected filter is availabe in UXL resplonse then increase count
            filterCount++;
          }
        });
      }
    });
    // Set the all filter active state to true if the selected filter count is greater than 0
    setAllFiltersActive(filterCount > 0 ? true : false);
    return filterCount;
  };

  const onUpdateCurrency = (curr: string): void => {
    setCurrCurrency(curr);
    setInteractionsSelected({ ...interactionsSelected, currencyConversion: true });
  };

  useEffect(() => {
    // initialize filter selection data from searchQueryState
    setUpdatedFilterSelectionData(getSearchFilterInitialState(searchQueryState));
    if (searchQueryState.currentCurrency !== 'default') {
      retriveFilterCount();
    }
  }, [searchQueryState]);

  useEffect(() => {
    retriveFilterCount();
  }, [filterSelectionData, searchResult]);

  const retriveFilterCount = () => {
    updateCategorizedBrands();
    let filterAppliedCount = getFilterCount();
    if (searchQueryState.currentCurrency !== DefaultValue) {
      filterAppliedCount++;
    }

    // remove brands count for boost brands scenario
    if (enableBoostBrands() === true) {
      const selectedbrandsCount = searchQueryState?.BRANDS ? Object.keys(searchQueryState?.BRANDS)?.length : 0;
      filterAppliedCount = filterAppliedCount - selectedbrandsCount;
    }
    setFilterCount(filterAppliedCount);
  };

  const onFilterChange = (type: SearchFacetsList, data: SearchStateFilterObj): void => {
    setFetchCurrencyConversionFactors(true);
    if (!updatedFilterSelectionData) {
      // Update the search query state for filters
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const filterState: any = {
        currentCurrency: 'default',
        includeTaxesAndFees: false,
        [SearchFacetsList.activities]: {},
        [SearchFacetsList.amenities]: {},
        [SearchFacetsList.brand]: {},
        [SearchFacetsList.cities]: {},
        [SearchFacetsList.distance]: {},
        [SearchFacetsList.meetingEvents]: {},
        [SearchFacetsList.price]: {},
        [SearchFacetsList.points]: {},
        [SearchFacetsList.propertyType]: {},
        [SearchFacetsList.states]: {},
        [SearchFacetsList.transportTypes]: {},
      };
      filterState[type] = { ...data };
      setSearchQuery({
        type: SearchActions.setApplyFilter,
        payload: filterState,
      });
      // Set interactions for session update
      setInteractionsSelected({
        ...interactionsSelected,
        ...{
          activities: true,
          amenities: true,
          brands: true,
          city: true,
          distance: true,
          events: true,
          price: true,
          points: true,
          hotelType: true,
          states: true,
          transportation: true,
          currencyConversion: true,
          taxesAndFees: true,
        },
      });
    }
    let obj1: SearchStateExtendsType = { ...updatedFilterSelectionData };
    if (updatedFilterSelectionData) {
      obj1[type] = data;
    } else {
      obj1 = {
        [type]: data,
      };
    }
    setUpdatedFilterSelectionData(obj1);
    if (!isFilterUpdate) {
      /*** if user interact with filter */
      setIsFilterUpdated(true);
    }
    eventUtil.dispatch('updateShopPageFilterModalValues', { ...searchQueryState, ...obj1 });
  };

  const extractFilterSelectionData = (payload: SearchStateExtendsType | null | undefined, filterApplied: boolean) => {
    const amenities = payload?.[SearchFacetsList.amenities]
      ? Object.values(payload?.[SearchFacetsList.amenities] as SearchStateFilterObj)
      : [];
    const transportationTypes = payload?.[SearchFacetsList.transportTypes]
      ? Object.values(payload?.[SearchFacetsList.transportTypes] as SearchStateFilterObj)
      : [];
    const brands = payload?.[SearchFacetsList.brand]
      ? Object.values(payload?.[SearchFacetsList.brand] as SearchStateFilterObj)
      : [];
    const hotelTypes = payload?.[SearchFacetsList.propertyType]
      ? Object.values(payload?.[SearchFacetsList.propertyType] as SearchStateFilterObj)
      : [];
    const activities = payload?.[SearchFacetsList.activities]
      ? Object.values(payload?.[SearchFacetsList.activities] as SearchStateFilterObj)
      : [];
    const events = payload?.[SearchFacetsList.meetingEvents]
      ? Object.values(payload?.[SearchFacetsList.meetingEvents] as SearchStateFilterObj)
      : [];
    const states = payload?.[SearchFacetsList.states]
      ? Object.values(payload?.[SearchFacetsList.states] as SearchStateFilterObj)
      : [];
    const cities = payload?.[SearchFacetsList.cities]
      ? Object.values(payload?.[SearchFacetsList.cities] as SearchStateFilterObj)
      : [];
    const points = payload?.[SearchFacetsList.points]
      ? Object.values(payload?.[SearchFacetsList.points] as SearchStateFilterObj)
      : filterApplied
      ? [0]
      : [];
    const distance = payload?.[SearchFacetsList.distance]
      ? Object.values(payload?.[SearchFacetsList.distance] as SearchStateFilterObj)
      : filterApplied
      ? [0]
      : [];
    const price = payload?.[SearchFacetsList.price]
      ? Object.values(payload?.[SearchFacetsList.price] as SearchStateFilterObj)
      : filterApplied
      ? [0]
      : [];

    return {
      amenities,
      transportationTypes,
      brands,
      hotelTypes,
      activities,
      events,
      states,
      cities,
      points,
      distance,
      price,
    };
  };

  const applyBtnHandler = (_mouseEvents?: React.MouseEvent, showTaxByDefault?: boolean): void => {
    setIsTaxesAndFeesToggled(false); // set this to false(reset to default) when user clicks on apply
    setFilterSelectionData(updatedFilterSelectionData);
    setFiltersApplied(true);
    const payload = updatedFilterSelectionData === undefined ? getSearchFilterClearState() : updatedFilterSelectionData;

    const extractedFiltersData = extractFilterSelectionData(payload, true);

    if (
      currCurrency !== searchQueryState.currentCurrency &&
      (getTotalFilterCount(payload) !== getTotalFilterCount(searchQueryState) || isFilterUpdate)
    ) {
      // in order to update the filter change with currency change we have to publish this event
      setIsFilterUpdated(false);
      eventUtil.dispatch('observeFilterChangeToUpdateTheDataWithCurrency', true);
    }
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    const showAvailableHotels: boolean = !isUnavailableProperties;
    // Update the selected filter values in the URL
    updateQueryParams(
      {
        amenities: extractedFiltersData.amenities,
        transportationTypes: extractedFiltersData.transportationTypes,
        brands: extractedFiltersData.brands,
        hotelTypes: extractedFiltersData.hotelTypes,
        activities: extractedFiltersData.activities,
        events: extractedFiltersData.events,
        states: extractedFiltersData.states,
        cities: extractedFiltersData.cities,
        includeTaxes,
        showAvailableHotels,
        selectedCurrency: currCurrency,
        distanceRangeIndex: [Number(extractedFiltersData.distance.length >= 1 ? extractedFiltersData.distance[0] : 0)],
        priceRangeIndex: [Number(extractedFiltersData.price.length >= 1 ? extractedFiltersData.price[0] : 0)],
        pointsRangeIndex: [Number(extractedFiltersData.points.length >= 1 ? extractedFiltersData.points[0] : 0)],
      },
      [
        'amenities',
        'transportationTypes',
        'brands',
        'hotelTypes',
        'activities',
        'events',
        'states',
        'cities',
        'includeTaxes',
        'showAvailableHotels',
        'selectedCurrency',
        'distanceRangeIndex',
        'priceRangeIndex',
        'pointsRangeIndex',
      ],
      headersData?.referer
    );

    setSearchQuery({
      type: SearchActions.updateCurrency,
      payload: {
        currentCurrency: currCurrency,
      },
    });
    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.unavailableProperties]: isUnavailableProperties,
      },
    });
    setSearchQuery({
      type: SearchActions.updateTaxesAndAvailability,
      payload: {
        [SearchFacetsConstants.includeTaxes]: showTaxByDefault || includeTaxes,
      },
    });
    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    // create copy of filterSelectionData and payload to compare the values using for loop
    const copyOfFilterSelectionData = JSON.parse(JSON.stringify(filterSelectionData));
    const copyOfPayload = JSON.parse(JSON.stringify(payload));

    //isFilterUpdated is used to determine if any value changed for filterSelectionData and payload
    let isFilterUpdated = false;
    for (const item in copyOfFilterSelectionData) {
      if (JSON.stringify(copyOfFilterSelectionData[item]) !== JSON.stringify(copyOfPayload[item])) {
        //comparing each filter data inside filterSelectionData and payload to determing if filters are changed.
        isFilterUpdated = true;
      }
    }
    //should call uxl is !isDTT, if ISDTT is true then call UXL only if filters are updated(excluding taxes and fee toggle) OR if sort option is SOrt by price then also call UXL for every scenario
    const shouldCallUXL =
      !isDTT ||
      (isDTT &&
        (isFilterUpdated ||
          (searchQueryState?.sort?.fields?.[0].field === SearchSortFields.price && isTaxesAndFeesToggled)));

    //call api only if filters are updated, this doesnot include taxed and fee toggle change OR if searchQueryState.includeUnavailableProperties has changed
    if (shouldCallUXL || searchQueryState.includeUnavailableProperties !== isUnavailableProperties) {
      setSearchQuery({
        type: SearchActions.setQuery,
        payload: {
          [SearchFacetsConstants.facets]: {
            ...searchQueryState.search[SearchFacetsConstants.facets],
            ...getSearchAppliedFilter(payload, searchQueryState),
          },
          [SearchFacetsConstants.options]: {
            ...searchQueryState.search[SearchFacetsConstants.options],
            [SearchFacetsConstants.includeTaxes]: true,
            [SearchFacetsConstants.unavailableProperties]:
              searchQueryState[SearchFacetsConstants.unavailableProperties],
          },
        },
      });
    }

    const taxAndCurrency = {
      includeTaxes: showTaxByDefault || includeTaxes,
      currCurrency: currCurrency,
    };
    setIsTaxesandFeesIncludedFromPopup(true);
    eventUtil.dispatch('taxAndCurrencySessionUpdate', taxAndCurrency);
    eventUtil.dispatch('callSessionData', true);
  };

  const updateIncludeTax = (val: boolean): void => {
    if (searchQueryState?.includeTaxesAndFees !== val) {
      setIsTaxesAndFeesToggled(true);
    } else {
      setIsTaxesAndFeesToggled(false);
    }
    setIncludeTaxes(val);
    setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
    if (!isFilterUpdate) {
      /*** if user interact with filter */
      setIsFilterUpdated(true);
    }
  };

  //get the country name from document lang in client side
  const getCountryFromDocumentLang = () => {
    if (typeof document === 'undefined') return '';
    return document.documentElement?.lang?.split(/[_-]/)?.[1]?.toUpperCase();
  };

  useEffect(() => {
    setCurrFilterData(filterData);
  }, [filterData]);

  useEffect(() => {
    if (!popupOpenState && !isMapViewEnabled && bodyRef.current) {
      bodyRef.current.style.overflow = 'auto';
    }

    if (!popupOpenState) {
      const payload = filterSelectionData === undefined ? getSearchFilterClearState() : filterSelectionData;
      setUpdatedFilterSelectionData(filterSelectionData);
      setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    }
  }, [popupOpenState]);

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;

    //for those countries where tax & fees will be enabled by default e.g NL
    if (
      COUNTRY_LIST_SHOW_FULL_PRICE_BY_DEFAULT.includes(getCountryFromDocumentLang()) ||
      COUNTRY_LIST_SHOW_FULL_PRICE_BY_DEFAULT.includes(getUserCountryCodeFromAkamai())
    ) {
      applyBtnHandler(undefined, true);
    }

    const extractedFiltersData = extractFilterSelectionData(filterSelectionData, false);
    if (
      (Object.values(filterSelectionData?.[SearchFacetsList.points] as SearchStateFilterObj).length ||
        Object.values(filterSelectionData?.[SearchFacetsList.distance] as SearchStateFilterObj).length ||
        Object.values(filterSelectionData?.[SearchFacetsList.price] as SearchStateFilterObj).length) !== 0
    ) {
      updateQueryParamsFromSession(extractedFiltersData, headersData, true);
    } else {
      updateQueryParamsFromSession(extractedFiltersData, headersData, filtersApplied);
    }
  }, []);

  return (
    <StyledAllFilterContainer className="filter-button">
      <Button
        className={clsx(
          'm-button-primary-inverse t-label-alt-m filter-option-button button--medium all-filter custom_click_track sm-search-result-all-filter-component-button',
          filterCount || filtersActive ? 'active' : ''
        )}
        callback={() => {
          setCurrFilterData(undefined);
          if (!isMapViewEnabled && bodyRef.current) {
            bodyRef.current.style.overflow = 'hidden';
          }
          setPopupOpenState(!popupOpenState);
          setFilterSelectionData(getSearchFilterInitialState(searchQueryState));
        }}
        custom_click_track_value={`${clickTrackingLoc}| Filter Selection: All Filters |internal`}
        buttonCopy={jsonContent?.allFilterLabel}
        isTextBeforeChildren={false}
      >
        {filterCount ? (
          <div className="t-font-xs all-filter-badge">{filterCount}</div>
        ) : (
          <div className="icon-s icon-dining-filter"></div>
        )}
      </Button>
      {popupOpenState && (
        <Modal
          className={`custom-scrollbar  ${popupOpenState ? '' : 'close-popup-header'}`}
          show={true}
          handleBlur={true}
          popupOpenState={popupOpenState}
          setPopupOpenState={setPopupOpenState}
          allFilterPopUp={true}
          onClose={(): void => {
            setCurrFilterData(undefined);
          }}
          role="dialog"
          labelledBy="ModalPopup"
          modalId="ModalPopup"
        >
          <Modal.Header
            labelText={jsonContent.filterLabel}
            popupHeaderOnCLoseFunc={() => {
              setIsTaxesAndFeesToggled(false); // set this to false(reset to default) when user clicks on cross cta
              setPopupOpenState(false);
              setIsFilterUpdated(false);
            }}
            customHeadingClass={isDesktop ? 't-subtitle-xl' : 't-subtitle-l'}
          />
          <Modal.Body className="all-filters custom-scrollbar" refElement={modalRefElement}>
            {hideAvailabiltyFilters ? (
              <div />
            ) : (
              <ShowAvailableFiltersComponent
                onItemChange={val => {
                  setIsUnavailableProperties(val);
                  if (!isFilterUpdate) {
                    /*** if user interact with filter */
                    setIsFilterUpdated(true);
                  }
                }}
              />
            )}
            {!hidePriceFilters ? (
              searchQueryState[SearchFacetsConstants.points] ? (
                <PointsFilter
                  clearFilterState={updatedFilterSelectionData}
                  onItemSelect={onFilterChange}
                  allFilterPopUp={true}
                  onIncludeTaxesChange={updateIncludeTax}
                  onCurrencyUpdate={onUpdateCurrency}
                  hideTaxesToggle={hideTaxesToggle}
                  itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.points)[0]}
                />
              ) : (
                <PriceFilter
                  clearFilterState={updatedFilterSelectionData}
                  onIncludeTaxesChange={updateIncludeTax}
                  onItemSelect={onFilterChange}
                  allFilterPopUp={true}
                  onCurrencyUpdate={onUpdateCurrency}
                  hideTaxesToggle={hideTaxesToggle}
                  itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.price)[0]}
                />
              )
            ) : (
              <div />
            )}

            <>
              {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') && (
                <AmenitiesFilterComponent
                  allFilterPopUp={true}
                  clearFilterState={updatedFilterSelectionData}
                  onItemSelect={onFilterChange}
                  itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.amenities)[0]}
                  tooltipRefElement={tooltipRefElement}
                  setTooltipContent={setTooltipContent}
                  modalRefElement={modalRefElement}
                />
              )}
            </>

            <BrandsFilterComponent
              allFilterPopUp={true}
              onItemSelect={onFilterChange}
              clearFilterState={updatedFilterSelectionData}
              itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.brand)[0]}
            />
            {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') && !hideDistanceFilters ? (
              <DistanceFilterComponent
                distancesList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.distance)[0]}
                clearFilterState={updatedFilterSelectionData}
                onItemSelect={onFilterChange}
              />
            ) : (
              <div />
            )}

            <>
              {!quickFiltersAndAmenitiesHiddenCodes.includes(searchResultAlerts?.code ?? '') && (
                <div className="result-based-filters">
                  <TransportationFilterComponent
                    transportationList={
                      currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.transportTypes)[0]
                    }
                    clearFilterState={updatedFilterSelectionData}
                    onItemSelect={onFilterChange}
                  />

                  <HotelTypeFilterComponent
                    hotelTypeList={
                      currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.propertyType)[0]
                    }
                    clearFilterState={updatedFilterSelectionData}
                    onItemSelect={onFilterChange}
                  />

                  <EventsFilterComponent
                    eventsList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.meetingEvents)[0]}
                    clearFilterState={updatedFilterSelectionData}
                    onItemSelect={onFilterChange}
                  />

                  <ActivitiesFilterComponent
                    itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.activities)[0]}
                    clearFilterState={updatedFilterSelectionData}
                    onItemSelect={onFilterChange}
                  />

                  <div className="state-search-filter">
                    {isDestinationSearch && isStateSearch ? (
                      <div></div>
                    ) : (
                      <StateFilterComponent
                        statesList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.states)[0]}
                        clearFilterState={updatedFilterSelectionData}
                        onItemSelect={onFilterChange}
                      />
                    )}
                  </div>

                  <CityFilterComponent
                    citiesList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.cities)[0]}
                    clearFilterState={updatedFilterSelectionData}
                    onItemSelect={onFilterChange}
                  />
                </div>
              )}
            </>
          </Modal.Body>
          <Modal.Footer
            clearClickHandler={(): void => {
              setIsTaxesAndFeesToggled(false); // set this to false(reset to default) when user clicks on clear
              setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
              setCurrFilterData(undefined);
              setIncludeTaxes(false);
              setUpdatedFilterSelectionData(filterSelectionData === undefined ? null : undefined);
            }}
            setPopUpOpenState={setPopupOpenState}
            applyBtnClickHandler={applyBtnHandler}
            clearButtonLabel={jsonContent.clearLabel}
            applyLabel={jsonContent.applyLabel}
            setFeatureSelected={setFeatureSelected}
            clickTrackingLoc={clickTrackingLoc}
            className={'pop-up-footer'}
          />
        </Modal>
      )}
    </StyledAllFilterContainer>
  );
};
